import {forwardRef, ReactNode} from 'react'
import {NavLinkProps} from 'react-router-dom'
import {ButtonStyleProps} from '@components/ui/button/Button.tsx'
import {StyledButtonNavLink} from '@components/ui/button-nav-link/style.ts'

export type ButtonNavLinkProps = Omit<NavLinkProps, 'children' | 'className' | 'style'> &
    ButtonStyleProps & {
        children?: ReactNode
        className?: HTMLAnchorElement['className']
        isExpanded?: boolean
    }

export const ButtonNavLink = forwardRef<HTMLAnchorElement, ButtonNavLinkProps>(({to, isExpanded, ...props}, ref) => (
    <StyledButtonNavLink ref={ref} to={to} $isExpanded={isExpanded} {...props} />
))
ButtonNavLink.displayName = 'ButtonNavLink'
